import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import {
  useGetCategory,
  useGetCustomer,
  useGetQuickInvoice,
  useShowTag,
} from "../../hooks/useCrm";
import { DataPicker } from "../DataPicker/DataPicker";
import { Categories, TagSelection } from "../../data/crmGeneralData";
import { useParams } from "react-router-dom";
import { formatDate } from "../../utils/formatDate";
export const QuickInvoiceModal = ({ show, handleClose }) => {
  const [button] = useState(false);
  const { id } = useParams();
  useEffect(() => {
    setForm({ ...form, IdS0alesOpportunities: id });
  }, [id]);
  const [form, setForm] = useState({
    IdS0alesOpportunities: null,
    IdProducts: null,
    DateSabtFactorSpeed: null,
    FactorTag: null,
    fastPrice: null,
    DepositAll: null,
    IdMarketer: null,
  });

  const { mutateAsync: QuickInvoice, isLoading } = useGetQuickInvoice();
  const { data: tags } = useShowTag();
  const handleSubmit = async (data) => {
    await QuickInvoice(data);
  };
  const categoriesOptions = Categories?.map((cat) => {
    return {
      value: cat.label,
      label: cat.value,
    };
  });
  const { data: customerresponsible } = useGetCustomer();
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const tagsOptions = tags?.data?.tags?.map((tag) => {
    return {
      value: tag.NameTag,
      label: tag.NameTag,
    };
  });
  return (
    <BootstrapModal
      modaltitle="فاکتور سریع"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-lg-6 col-md-6 col-12">
          <SimpleSelect1
            res={categoriesOptions}
            label="دسته بندی محصولات"
            onChange={(e) => setForm({ ...form, IdProducts: e.value })}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <DataPicker
            onChange={(e) =>
              setForm({ ...form, DateSabtFactorSpeed: formatDate(e) })
            }
            label="تاریخ"
          />
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <SimpleSelect1
            res={tagsOptions}
            label="برچسب"
            onChange={(e) => setForm({ ...form, FactorTag: e.value })}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <InputField1
            placeholder="قیمت"
            label="قیمت"
            onChange={(e) => setForm({ ...form, fastPrice: e.target.value })}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <InputField1
            placeholder="پرداختی"
            label="پرداختی"
            onChange={(e) => setForm({ ...form, DepositAll: e.target.value })}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <SimpleSelect1
            label="مسئول فاکتور"
            res={customerResponsibleOptions}
            onChange={(e) => setForm({ ...form, IdMarketer: e.value })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleSubmit(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
        <div className="col-6">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
